export class SeedingPost {
    _id = '';
    target_link='';
    isLike = false;
    reaction=Array();

    time_before_like_from = 2;
    time_before_like_to = 5;

    time_after_like_from = 2;
    time_after_like_to = 4;

    isShare = false;
    max_group = 5;
    is_share_personal = false;
    groups = Array();
    content_share = '';
    time_before_share_from = 2;
    time_before_share_to = 5;

    time_after_content_share_from = 2;
    time_after_content_share_to = 4;

    time_after_share_from = 2;
    time_after_share_to = 4;

    isComment = false;
    content_comments = Array();
    time_before_comment_from = 2;
    time_before_comment_to = 5;
    time_after_content_comment_from = 2;
    time_after_content_comment_to = 4;
    time_after_comment_from = 2;
    time_after_comment_to = 4;
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/seeding_post.ts